<template>
  <router-view />

  <!-- <h1 class="absolute text-white left-16 top-16 lg:hidden">
    <template v-if="$route.name === 'Room01'">
      Studio Exclusive
    </template>
    <template v-if="$route.name === 'Room02'">
      1 Bedroom
    </template>
    <template v-if="$route.name === 'Room02'">
      1 Bedroom Plus
    </template>
  </h1> -->

  <button
    class="absolute bottom-0 left-0 z-50 flex items-center justify-center w-16 h-16 bg-white bg-opacity-75 rounded-none shadow-lg lg:hidden backdrop-blur"
    @click="active = !active"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 283.426 283.426"
      class="w-8 h-8 pointer-events-none opacity-40"
    >
      <g>
        <rect
          x="0"
          y="40.84"
          style="fill:#010002;"
          width="283.426"
          height="47.735"
        />
        <rect
          x="0"
          y="117.282"
          style="fill:#010002;"
          width="283.426"
          height="47.735"
        />
        <rect
          x="0"
          y="194.851"
          style="fill:#010002;"
          width="283.426"
          height="47.735"
        />
      </g>
    </svg>
  </button>

  <div
    class="fixed bottom-0 left-0 flex-col p-8 text-black uppercase lg:m-8 lg:flex backdrop-blur lg:backdrop-none"
    :class="{
      'hidden': !active,
      'flex inset-0 bg-black bg-opacity-50 justify-end pb-24': active
    }"
    @click="active = false"
  >
    <div class="flex flex-col max-w-xs space-y-4 md:justify-items-stretch md:max-w-none md:flex-row md:space-y-0 md:space-x-4">
      <router-link
        to="/01"
        class="px-8 py-2 bg-white bg-opacity-75 shadow-lg backdrop-blur"
        active-class="font-bold text-white bg-secondary-500"
      >
        Studio Exclusive
      </router-link>
      <router-link
        to="/02"
        class="px-8 py-2 bg-white bg-opacity-75 shadow-lg backdrop-blur"
        active-class="font-bold text-white bg-secondary-500"
      >
        1 Bedroom
      </router-link>
      <router-link
        to="/03"
        class="px-8 py-2 bg-white bg-opacity-75 shadow-lg backdrop-blur"
        active-class="font-bold text-white bg-secondary-500"
      >
        1 Bedroom Plus
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      active: false,
    }
  },
}
</script>

<style src="@/assets/css/app.css"></style>
